import { render, staticRenderFns } from "./invoice-info-details.vue?vue&type=template&id=b6b432ca&scoped=true"
import script from "./invoice-info-details.vue?vue&type=script&lang=js"
export * from "./invoice-info-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b432ca",
  null
  
)

export default component.exports